__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2026-08-12-1786537439-stable-dev/";